export default __webpack_public_path__ + "static/media/la_ferte-vidame01min.3884ac73.jpg";